import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* 背景画像 */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://static.readdy.ai/image/4df5c7deddaddbbeeb26e7a7cacf2afd/40e3bbed2f1d9ae117ef215559334ac2.jpeg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        {/* オーバーレイ */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* 装飾的な円形要素 */}
      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-sage opacity-20 rounded-full blur-3xl z-10" />
      <div className="absolute bottom-1/3 left-1/4 w-80 h-80 bg-mustard opacity-15 rounded-full blur-3xl z-10" />
      <div className="absolute top-1/2 right-1/3 w-64 h-64 bg-white opacity-10 rounded-full blur-2xl z-10" />

      <div className="relative z-20 px-8 lg:px-16 max-w-7xl mx-auto w-full text-center">
        <div className="max-w-5xl mx-auto">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="font-serif text-7xl lg:text-8xl tracking-[0.15em] text-white mb-8 drop-shadow-lg"
          >
            SINAX
          </motion.h1>

          <p className="text-lg lg:text-xl text-white/90 mb-12 leading-relaxed max-w-2xl mx-auto">
            ITと現場をつなぎ、共に未来を創造する
          </p>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="font-sans text-lg text-white/90 mb-12 leading-loose max-w-3xl mx-auto drop-shadow-md"
          >
            SINAXは、人と人の縁を起点に、構想から実行まで伴走する実行型のITパートナーです。<br />
            信頼と共創を大切に、しなやかに変化に対応しながら、お客様と共に価値を創造します。
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
            className="flex flex-wrap gap-4 justify-center"
          >
            <a
              href="#contact"
              className="whitespace-nowrap px-8 py-3.5 bg-mustard text-white text-base font-sans tracking-wide rounded cursor-pointer transition-all duration-300 hover:bg-opacity-90 group relative overflow-hidden shadow-lg"
            >
              お問い合わせ
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full" />
            </a>
            <Link
              to="/services"
              className="whitespace-nowrap px-8 py-3.5 bg-white/90 backdrop-blur-sm text-darkgray text-base font-sans tracking-wide rounded cursor-pointer transition-all duration-300 hover:bg-white group relative overflow-hidden shadow-lg"
            >
              事業を見る
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-darkgray transition-all duration-300 group-hover:w-full" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
